import { render, staticRenderFns } from "./Communication.vue?vue&type=template&id=59d3245a&scoped=true&"
import script from "@/views/Reports/Communication/Communication.ts?vue&type=script&lang=ts&"
export * from "@/views/Reports/Communication/Communication.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Reports/Communication/communication.scss?vue&type=style&index=0&id=59d3245a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d3245a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCheckbox,VFlex,VSelect,VTextarea})
